import React, { useEffect, useState } from "react";
import MoveFolder from "../components/folder/MoveFolder";
import { getDirList } from "./service";

type Props = {
  open: boolean;
  onConfirm: (params: { folderId: number }) => void;
  onCancel: () => void;
};

export default function MoveFolderModal(props: Props) {
  const [folderList, setFolderList] = useState<{ id: number; name: string }[]>(
    []
  );

  useEffect(() => {
    getDirList().then((res) => {
      if (res && Array.isArray(res)) {
        setFolderList(res);
      }
    });
  }, []);

  return <MoveFolder folderList={folderList} {...props} />;
}
